import  { useCallback, useEffect } from "react";
import { useDispatch, useSelector } from "react-redux";

import * as AttendanceActions from "../redux/actions/AttendanceAction"
import * as SettingActions from "../redux/actions/SettingAction"
import { HideSpinner, ShowSpinner } from "../redux/actions/SpinnerAction";
import { ErrorToast, SuccessToast } from "../redux/actions/ToasterAction";

import { useHierarchyService } from "./useHierarchyService";

import { FormattedDateString } from "../utilities/DateHelper";
import { ExpandAll } from "../utilities/TreeHelper";
import _ from 'lodash'

const useAttendance = ({refreshTree = true})=>{
    const {actions:{GetMultipleLocationTreeWithFilter,  RefreshTree} }= useHierarchyService(); 
   
    const filter = useSelector((state)=>{
        return state.attendance.filter;
    })

    const isFilterApplied = useSelector((state)=>{
        return state.attendance.isFilterApplied;
    })

    const selectedLocations = useSelector((state)=>{
        return state.attendance.filter.selectedLocations
    })

    const defaultExpandedKeys = useSelector((state)=>{
        return state.attendance.defaultExpandedKeys;
    })

    const attendanceOptions = useSelector((state)=>{        
        return _.filter(state.setting.allAttendanceStatus, (a)=>a.isActive);
    })

    const dispatchAttendance = useDispatch();

    const InitializeDefaults = useCallback((date, selectedLocations)=>{
        var action = AttendanceActions.InitialDefaults(date, selectedLocations)
        dispatchAttendance(action) 
    }, [dispatchAttendance])

    const SetSelectedLocations = useCallback((selectedLocations)=>{
        var action = AttendanceActions.SetSelectedLocations(selectedLocations)
        dispatchAttendance(action)
    }, [dispatchAttendance])

    const SetSelectedDate = useCallback((date)=>{
        var action =  AttendanceActions.SetSelectedDate(date);       
        dispatchAttendance(action);   

    }, [dispatchAttendance])

    const SetFilter = useCallback((data)=>{
        var action =  AttendanceActions.SetFilter(data);       
        dispatchAttendance(action);   

    }, [dispatchAttendance])

    const ResetFilter = useCallback((data)=>{
        var action =  AttendanceActions.ResetFilter(data);       
        dispatchAttendance(action);   

    }, [dispatchAttendance])

    const SetDefaultExpandedKeys = useCallback((expandedKeys)=>{
        var action = AttendanceActions.SetDefaultExpandedKeys(expandedKeys);
        dispatchAttendance(action);
    }, [dispatchAttendance])

    const GetAllAttendanceOptions = useCallback(async ()=>{
        try{
            var action = await SettingActions.GetAttendanceStatus();
            dispatchAttendance(action)
        }
        catch(err){
            dispatchAttendance(ErrorToast('Error', _.get(err, 'response.data.message') || err));
        }
    }, [dispatchAttendance])

    const MarkAttendance = useCallback(async(attendance)=>{
        try{
            dispatchAttendance(ShowSpinner());
            var action = await AttendanceActions.MarkAttendance(attendance);
            dispatchAttendance(action);
            await RefreshTree(filter);
            dispatchAttendance(HideSpinner());
            dispatchAttendance(SuccessToast('Success', 'Attendance successfully updated.'));
        }
        catch(err) {         
            dispatchAttendance(HideSpinner());
            dispatchAttendance(ErrorToast('Error', _.get(err, 'response.data.message') || err));
          }    

    }, [dispatchAttendance, RefreshTree, filter])

    useEffect(()=>{       
        const GetTreeDataAsync = async ()=>{
            if(refreshTree && !_.isNull(filter.date) && !_.isNull(filter.selectedLocations)){         
                const treeData = await GetMultipleLocationTreeWithFilter({...filter, date:FormattedDateString(filter.date), locationIds:filter.selectedLocations.map((l)=>l.id)} ) 
                let expandedKeys = {};   
                isFilterApplied && _.forEach(treeData, (tree)=>{expandedKeys = {...expandedKeys, ...ExpandAll(tree, expandedKeys)}});
                SetDefaultExpandedKeys(expandedKeys);
                GetAllAttendanceOptions();
            }
        }
        GetTreeDataAsync();
    }, [refreshTree, filter, isFilterApplied, GetMultipleLocationTreeWithFilter, SetDefaultExpandedKeys, GetAllAttendanceOptions])

    return {data:{selectedLocations, filter, isFilterApplied, defaultExpandedKeys, attendanceOptions}, actions:{InitializeDefaults, SetSelectedLocations, SetSelectedDate, SetFilter, ResetFilter, MarkAttendance}}
}

export default useAttendance;